export default __webpack_public_path__ + "static/line-7f671f33a5c6544de3b3a20ad4f81fc3.svg";